import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=2dc39f55&lang=pug"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"
import style0 from "./loading.vue?vue&type=style&index=0&id=2dc39f55&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports